import { StepContainer } from '../components/StepContainer'
import { SingleSelect } from '../components/SingleSelect'
import { useOnboardingStore } from '../store/onboardingStore'
import type { MotivationSource } from '../types/onboarding'

const options: { value: MotivationSource; label: string; emoji: string }[] = [
  { value: 'health', label: 'Protect my kidney health', emoji: '🏥' },
  { value: 'family', label: 'Be there for my family', emoji: '👨‍👩‍👧' },
  { value: 'labs', label: 'Improve my lab results', emoji: '📊' },
  { value: 'avoid_dialysis', label: 'Avoid or delay dialysis', emoji: '🛡️' },
  { value: 'energy', label: 'Feel better day-to-day', emoji: '⚡' },
  { value: 'control', label: 'Take control of my diet', emoji: '💪' },
]

export function MotivationStep() {
  const { data, goNext } = useOnboardingStore()

  return (
    <StepContainer
      title="What motivates you most?"
      showContinue={false}
    >
      <SingleSelect
        options={options}
        value={data.motivationSource}
        onChange={(value) => goNext({ motivationSource: value })}
      />
    </StepContainer>
  )
}
